import { FetchPort } from "./fetch-api";
import { PlanDetails, PaypalPlanSet } from "./paypal-api";
import { PublicEnvironment } from "./public-env";

export enum Mode {
    DEVELOPMENT = "dev",
    PRODUCTION = "prod"
}
export interface CodecsPort {
    toBase64(message: string): string;
    fromBase64(message: string): string;
}

export interface SecretEnvironment {
    readonly paypalSecret: string;
    readonly firebaseServiceAccount: {};
}

export default class AddonCore {

    private publicEnvironment: PublicEnvironment | null = null;

    private readonly fetchPort: FetchPort;
    private readonly codecsPort: CodecsPort;

    constructor(
        _fetchPort: FetchPort,
        _codecsPort: CodecsPort
    ) {

        this.fetchPort = _fetchPort;
        this.codecsPort = _codecsPort;
    }

    public withPublicEnvironment(_publicEnv: PublicEnvironment) {
        this.publicEnvironment = _publicEnv;
        return this;
    }

    public fetch(url: string, options: {}): Promise<string> {
        return this.fetchPort.get(url, options);
    }

    public encodeObject<T>(obj: T): string {
        return this.codecsPort.toBase64(JSON.stringify(obj));
    }

    public decodeObject<T>(msg: string): T {
        return JSON.parse(this.codecsPort.fromBase64(msg));
    }

    /*
     * Detect visitor's country code by cloudflare.
     *
     * Country code reference:  https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
     */
    private getClientCountryCode(): Promise<string> {
        return this.fetchPort
            .get('https://www.cloudflare.com/cdn-cgi/trace', {
                method: "get"
            })
            .then(function (data) {
                if (data === null || data === undefined) {
                    return "";
                }
                const locMatch = data.match(/loc=(.+)/i);
                if (locMatch === null) return "";
                let countryCode = locMatch[1];
                countryCode = countryCode ? String(countryCode).toUpperCase() : "";
                return countryCode;
            });
    }

    private filterPlanIdsByCountryCode(countryCode: string, paypalPlanSets: PaypalPlanSet[]): string[] {

        // if a plan set contains country code
        for (const ps of paypalPlanSets) {
            if (ps.codes.indexOf(countryCode) > -1) {
                return ps.plans;
            }
        }
        // fallback to default plan set
        for (const ps of paypalPlanSets) {
            if (ps.codes.length === 0) {
                return ps.plans;
            }
        }
        return [];
    }

    public getPaypalPlans(paypalPlanSets: PaypalPlanSet[], urlPaypalPlanById: string): Promise<PlanDetails[]> {
        return this.getClientCountryCode()
            .then((countryCode) =>
                Promise.all(
                    this.filterPlanIdsByCountryCode(countryCode, paypalPlanSets)
                        .map(id => this.fetchPort
                            .get(`${urlPaypalPlanById}/${id}`, { method: "get" })
                            .then(JSON.parse))
                ));
    }

    public requestPaypalServicePlanById(id: string, secretEnv: SecretEnvironment): Promise<PlanDetails> {
        if (this.publicEnvironment === null) {
            return Promise.reject("missing public environment");
        }
        return this.fetchPort
            .get(`${this.publicEnvironment.paypalEndpoint}/v1/billing/plans/${id}`,
                {
                    method: "get",
                    headers: {
                        "Authorization": "Basic " + this.codecsPort.toBase64(`${this.publicEnvironment.paypalClientId}:${secretEnv.paypalSecret}`),
                        'Content-Type': 'application/json'
                    }
                }).then(JSON.parse);
    }
}